module.exports = __webpack_public_path__ + "img/136.9.46b83aa8.png";